import { ref } from 'vue';

/**
 * Chrome/Edge (Android, desktop) fire beforeinstallprompt once the app is installable. It is kept here so the
 * banner can show a real "Installera" button and open the browser's own install dialog. Safari never fires it.
 */
export const installPrompt = ref(null);

export function captureInstallPrompt() {
    window.addEventListener('beforeinstallprompt', (event) => {
        event.preventDefault(); // show our button instead of the browser's mini-infobar
        installPrompt.value = event;
    });
    window.addEventListener('appinstalled', () => {
        installPrompt.value = null;
    });
}

/** Opens the browser's install dialog. True when the user accepted. */
export async function promptInstall() {
    const event = installPrompt.value;
    if (!event)
        return false;
    installPrompt.value = null; // can only be used once
    event.prompt();
    const choice = await event.userChoice;
    return choice && choice.outcome === 'accepted';
}
